import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { notificationActions } from '../actions/notificationActions'
import { userSchemaRegister } from '../validation/userSchemaRegister'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { Grid, Button, Typography, Divider, MenuItem, Link, Box } from '@mui/material'
import { FormTextField, SelectMap as Select } from '../controls'
import { codigosPais } from '../helpers/codigosPais'
import { getValidateCuit, registerUser } from '../apis/accountRequests'
import { makeRequest } from '../apis/makeRequest'
import { trackSignUp } from '../helpers/analytics'
import { trackSignUpMeta } from '../helpers/meta'

const fields = userSchemaRegister.describe().fields


const identySelectOptions = ["CUIT"]
export default function AccountRegister() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [identyOption, setIdentyOption] = useState("CUIT")
    const [countryCode, setCountryCode] = useState('');
    const [country, setCountry] = useState('');
    const [dynamicsIdExist, setDynamicsIdExist] = useState("")
    const [validCuit, setValidCuit] = useState(true)
    const { control, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(userSchemaRegister),
        reValidateMode: 'onBlur',
    })

    const onSubmit = data => {
        data.roles = ['Usuario', 'Cliente']
        //data.tipoDocumento = identyOption
        data.tipoDocumento = 80
        data.CountryCode = countryCode
        data.dynamicsId = dynamicsIdExist
        data.FullName = data.razonSocial
        data.Active = 0
        if (identyOption === "") return dispatch(notificationActions.showError({ message: 'Debe seleccionar un tipo de documento' }))
        registerUser(data)
            .then(res => {
                dispatch(notificationActions.showSuccess({ message: `Se ha creado con éxito el usuario` }))
                trackSignUp(data.email, data.cuit)
                trackSignUpMeta(data.email, data.cuit)
                navigate('/login')
            })
            .catch(err => {
                dispatch(notificationActions.showError({ message: 'Error al crear el usuario' }))
                // err.response.data.errors.some(r => errorPassword.includes(r.code)) ?
                //     dispatch(notificationActions.showError({ message: 'la contraseña no cumple con los requisitos' })) :
                //     dispatch(notificationActions.showError({ message: 'Ha ocurrido un error al crear el usuario' }))
            })
    }

    const handleCountryCodeChange = (e) => {
        const selectedCode = e.target.value;
        setCountryCode(selectedCode);
        setCountry(codigosPais[selectedCode] || '');
    };

    const validateCuit = (cuit) => {
        getValidateCuit(cuit)
            .then((res) => {
                setValidCuit(res.data.valid);
                if (res.data.dynamicsId) {
                    return setDynamicsIdExist(res.data.dynamicsId);
                } else {
                    return setDynamicsIdExist(null);
                }
            })
            .catch(err => {
                dispatch(notificationActions.showError({ message: 'Ha ocurrido un error al validar el CUIT' }))
            })
    }

    const instructivo = `${process.env.PUBLIC_URL}/pdf/instructivo.pdf`;

    return (
        <form onSubmit={handleSubmit(onSubmit)} style={{ padding: "1em"}}>
           <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center"  width="100%" textAlign="center">
             <Typography fontSize="14px" fontStyle="italic" variant='p' gutterBottom> 
            *Es condición para poder acceder al portal ser cliente o tener un comercio y ser <strong>Contribuyente con CUIT Activo.</strong> Este portal es exclusivo para libreros, no contamos con venta al público y/o al por menor.
            </Typography>
           </Box>
            <Divider style={{ marginBottom: '1em' }} />
            <Grid container direction='row' justifyContent='center' alignItems='stretch' spacing={1}>
                <Grid item xs={12} md={5}>
                    <FormTextField size='small' name='userName' style={{ width: "100%" }}
                        control={control} schema={fields.userName} formErrors={errors.userName} />
                </Grid>
                <Grid item xs={12} md={5}>
                    <FormTextField size='small' name='razonSocial' style={{ width: "100%" }}
                        control={control} schema={fields.razonSocial} formErrors={errors.razonSocial} />
                </Grid>
                <Grid item xs={12} md={5}>
                    <Select readOnly size='small' label='Tipo de documento *' style={{ width: "100%" }} value={identyOption}
                        onChange={(e) => setIdentyOption(e.target.value)}>
                        <MenuItem value={""}>-</MenuItem>
                        {identySelectOptions.map((option, index) => (
                            <MenuItem key={`${option}-${index}`} value={option}>{option}</MenuItem>
                        ))}
                    </Select>
                </Grid>
                <Grid item xs={12} md={5}>
                    <FormTextField size='small' name='cuit' style={{ width: "100%" }} onBlur={e => validateCuit(e.target.value)}
                        control={control} schema={fields.cuit} formErrors={!validCuit ? "Ingrese un cuit valido": errors.cuit} helperText={!validCuit && "Ingrese un cuit valido"} />
                </Grid>
                <Grid item xs={12} md={5}>
                    <FormTextField size='small' name='email' style={{ width: "100%" }}
                        control={control} schema={fields.email} formErrors={errors.email} />
                </Grid>
                <Grid item xs={12} md={5}>
                    <FormTextField size='small' name='phoneNumber' style={{ width: "100%" }}
                        control={control} schema={fields.phoneNumber} formErrors={errors.phoneNumber} />
                </Grid>
                <Grid item xs={12} md={5}>
                    <FormTextField size='small' name='address' style={{ width: "100%" }}
                        control={control} schema={fields.address} formErrors={errors.address} />
                </Grid>
                <Grid item xs={12} md={5}>
                    <FormTextField size='small' name='city' style={{ width: "100%" }}
                        control={control} schema={fields.city} formErrors={errors.city} />
                </Grid>
                <Grid item xs={12} md={5}>
                    <FormTextField size='small' name='state' style={{ width: "100%" }}
                        control={control} schema={fields.state} formErrors={errors.state} />
                </Grid>
                <Grid item xs={12} md={5}>
                    <FormTextField size='small' name='zip' style={{ width: "100%" }}
                        control={control} schema={fields.zip} formErrors={errors.zip} />
                </Grid>
                <Grid item xs={12} md={5}>
                    <Select size='small' name='codigoPais' label='Codigo de pais *' style={{ width: "100%" }} value={countryCode} onChange={handleCountryCodeChange}>
                        <MenuItem value={""}>-</MenuItem>
                        {Object.keys(codigosPais).map((option, index) => (
                            <MenuItem key={`${option}-${index}`} value={option}>{option} - {codigosPais[option]}</MenuItem>
                        ))}
                    </Select>
                </Grid>
                <Grid item xs={12} md={5}>
                    <FormTextField size='small' name='country' style={{ width: "100%" }}
                        control={control} schema={fields.country} formErrors={errors.country} readOnly value={country} />
                </Grid>
                <Grid item xs={12} md={5} />
                <Typography fontSize="16px" fontStyle="italic" variant='caption' align='center' marginTop="15px">
                    Una vez registrado deberá esperar nuestro correo de validación en el transcurso de las 48hs hábiles para poder ingresar/operar.
                </Typography>
                <Grid item xs={12} textAlign="center">
                    <Link style={{ color: "black", textDecorationColor: "black" }} variant='caption' href={instructivo} download={"instructivo.pdf"} >
                        Descargar Instructivo
                    </Link>
                </Grid>
                <Grid item xs={12} style={{ paddingBottom: 2 }}>
                    <Button fullWidth type='submit' disabled={!validCuit} style={{
                        color: "white",
                        backgroundColor: !validCuit ? "grey" : "black",
                        transition: "all 0.2s ease-in-out",
                        '&:hover': {
                            backgroundColor: "black",
                            opacity: "0.6"
                        },
                    }}>
                        Confirmar
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}